module.exports = __webpack_public_path__ + "static/blind-soprano-shoots-for-the-moon-8f7471a7a6ae71d4eb789a83c9a3a435.jpg";